import { FC } from 'react';
import { useAdditionalTitleBarDatePicker } from '../../../../hooks/useAdditionalTitleBarComponents';
import useTitleBarDatePicker from '../../../../hooks/useTitleBarDatePicker';
import {
  getMostRecentWeekday,
  getWeekdayXMonthsAgo,
} from '../../../../utilities/dateUtilities';
import DailyPAndL from './charts/daily/Daily.component';
import SharePrice from './charts/sharePrice/SharePrice.component';
import ExceedanceTable from './tables/exceedanceTable/exceedanceTable.component';
import OutSampleTable from './tables/outSampleTable/outSample.component';
import dayjs from 'dayjs';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useVarBacktestQuery, VarBacktestApiResponse } from './queries';
import GridItem from '../../../layout/GridComponents/GridItem';

const VarBacktest: FC<FundInfoComponentProps> = (props) => {
  const startDateWeekday = getWeekdayXMonthsAgo(12);
  const endDateWeekday = getMostRecentWeekday();

  useAdditionalTitleBarDatePicker({
    displayOnOverviewPage: true,
    titleBarKey: 'startDate',
    titleBarTitle: 'Start Date: ',
    currentValue: dayjs(startDateWeekday).format('YYYY-MM-DD'),
  });

  useAdditionalTitleBarDatePicker({
    displayOnOverviewPage: true,
    titleBarKey: 'endDate',
    titleBarTitle: 'End Date: ',
    currentValue: dayjs(endDateWeekday).format('YYYY-MM-DD'),
  });
  const activeFund = props.fundId;

  const fromDate = useTitleBarDatePicker('startDate');
  const toDate = useTitleBarDatePicker('endDate');

  const fromDateStr = fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : null;
  const toDateStr = toDate ? dayjs(toDate).format('YYYY-MM-DD') : null;

  const { data, isLoading, isFetching, isError } = useVarBacktestQuery(
    activeFund,
    fromDateStr,
    toDateStr,
  );

  if (!fromDateStr || !toDateStr) {
    return (
      <GridItem xs={12} card cardStyle={{ padding: '0.62rem' }}>
        <h2 className="pb-2 text-mainblue">Choose a date</h2>
        <p className="text-gray-600">
          Select both start and end dates in the title bar to run the VaR
          backtest.
        </p>
      </GridItem>
    );
  }

  return (
    <QueryBoundary<VarBacktestApiResponse>
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      data={data}
      loadingMessages={['Running VaR backtest...']}
    >
      {(data) => (
        <>
          <OutSampleTable varBacktestData={data} />
          <DailyPAndL varData={data} />
          <ExceedanceTable varData={data} />
          <SharePrice varData={data} />
        </>
      )}
    </QueryBoundary>
  );
};
export default VarBacktest;
